import { Howl, Howler } from 'howler';
//import { ALPHA_MODES } from '../www/libs/pixi';
//https://github.com/goldfire/howler.js#documentation
export default class Audio {
    constructor() {
        this.sounds = {}
        this.isMuted = false;
        this.interactionListeners = null;

        // Log initial Howler context status
        console.log('Howler context initial state:', Howler.ctx ? Howler.ctx.state : 'No context');

    }

    load(id, src) {

        const sound = new Howl({
            html5: false,
            src: [src]
        });
        //const sound = new window.Audio(src);
        ////remove old sound and unload and destroy
        if (this.sounds[id] && this.sounds[id].unload) this.sounds[id].unload();
        this.sounds[id] = sound;
    }
    play(id) {
        if (this.isMuted) return;

        let sound = this.sounds[id];
        if (!sound) return;

        // Log context state before playing
        //console.log('Playing sound:', id, 'Context state:', Howler.ctx.state);



        //iOS requires user interaction to start(restart) audio context
        this.setUpToRestoreContextOnInteraction();

        if (this.canPlayAudio() === false) return;





        sound.play();

        // const sound = PIXI.sound.find(id);
        // //multi play a not preloaded resource cause crash - https://github.com/pixijs/sound/issues/71
        // if (sound && sound.isLoaded) {
        //     PIXI.sound.play(id);
        // }
    }
    muteSet(isMuted) {
        this.isMuted = isMuted;

        // if (isMuted) Howler.volume(0);
        // else Howler.volume(1);

        // if (isMuted) PIXI.sound.volumeAll = 0;
        // else PIXI.sound.volumeAll = 1;
    }
    canPlayAudio() {
        if (this.isMuted) return false;
        if (Howler.ctx && (Howler.ctx.state === 'suspended' || Howler.ctx.state === 'interrupted')) {
            return false;
        }
        return true;

    }
    setUpToRestoreContextOnInteraction() {
        //ios requires user interaction to start audio context and to restore it.  
        //if context is suspended, set up interaction listeners and skip playing now
        //context will be restored on next user interaction and only can be restored with an interaction on ios
        //seems to also never restore if audio is played while in the active suspended state which will not show suspended
        //safari has an extra level audio blocking based on user interaction outside of just the context state
        if (Howler.ctx) {

            // Check context state and manage interaction listeners accordingly
            if (Howler.ctx.state === 'suspended' || Howler.ctx.state === 'interrupted') {
                console.log('Audio context is suspended - skipping sound playback');
                // Set up interaction listeners to restore context
                this.setupIOSInteractionListeners();
                return;
            } else if (Howler.ctx.state === 'running') {
                // Remove interaction listeners if context is running
                this.removeIOSInteractionListeners();
            }
        }
    }

    // Call this method on user interactions to restore context if needed
    restoreContextIfNeeded() {
        if (Howler.ctx && (Howler.ctx.state === 'suspended' || Howler.ctx.state === 'interrupted')) {
            console.log('Attempting to restore audio context on user interaction...');
            Howler.ctx.resume().then(() => {
                console.log('Audio context restored successfully');
            }).catch(err => {
                console.error('Failed to restore audio context:', err);
            });
        }
    }

    setupIOSInteractionListeners() {
        // Only set up if not already listening
        if (this.interactionListeners) return;

        console.log('Setting up iOS interaction listeners for audio context restoration');

        // iOS requires user interaction to enable audio context
        const iosEvents = ['touchstart', 'touchend', 'click', 'mousedown'];

        const onIOSInteraction = () => {
            this.restoreContextIfNeeded();
        };

        // Store references to remove later
        this.interactionListeners = {
            handler: onIOSInteraction,
            events: iosEvents
        };

        iosEvents.forEach(event => {
            document.addEventListener(event, onIOSInteraction, { passive: true });
        })
    }

    removeIOSInteractionListeners() {
        if (!this.interactionListeners) return;

        console.log('Removing iOS interaction listeners - audio context is running');

        this.interactionListeners.events.forEach(event => {
            document.removeEventListener(event, this.interactionListeners.handler);
        });

        this.interactionListeners = null;
    }
}